{
  "title": "Réinitialiser mot de passe",
  "subtitle": "Choisissez un mot de passe sécurisé",
  "newPasswordLabel": "Nouv. mot de passe",
  "confirmPasswordLabel": "Confirmer mot de passe",
  "resetButton": "Réinitialiser",
  "resettingButton": "Réinitialisation...",
  "backToLogin": "Retour connexion",
  "requirementsText": "Doit contenir au moins 8 caractères avec majuscules, minuscules et chiffres",
  "strengthLabel": "Force : {{strength}}",
  "passwordStrength": {
    "tooShort": "Trop court",
    "weak": "Faible",
    "fair": "Moyen",
    "good": "Bon",
    "strong": "Fort"
  },
  "invalidLink": {
    "title": "Lien invalide",
    "backButton": "Retour connexion"
  },
  "errors": {
    "tooShort": "Le mot de passe doit contenir au moins 8 caractères",
    "needsUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
    "needsLowercase": "Doit contenir au moins une lettre minuscule",
    "needsNumber": "Le mot de passe doit contenir au moins un chiffre",
    "noMatch": "Mots de passe différents",
    "invalidOrExpired": "Lien de réinitialisation invalide ou expiré. Veuillez en demander un nouveau.",
    "genericError": "Une erreur s'est produite. Veuillez réessayer."
  }
}
